<template>
    <page title="dashboardTitle">
        <template #pageContainer>
            <div v-if="!IsAuthenticated">
                <p>Willkommen beim Seltec Portal.</p>
                <p>
                    Dieses Portal wird in Zukunft abgeschaltet! Alle Funktionen finden Sie auf <a href="https://www.lanet3.com">www.lanet3.com</a>!
                </p> 
                <p>
                    Die Bestenlisten Administration finden Sie auf <a href="https://statistics.lanet3.com">statistics.lanet3.com</a>!
                </p>    
                <p>
                    Sollten Sie keine Bestenlisten sehen, müssen Sie nochmals die Statistiker Rolle für Ihren Verein, Kreis, Bezirk oder LV beantragen!
                </p>                
               <p>                    
                    Bitte entschuldigen Sie die Unannehmlichkeiten.
                </p>      
                <p>
                   Bei Fragen wenden Sie sich bitte an support@seltec-sports.com
                </p>        
            </div>
            <div v-else>
                <p>Willkommen beim Seltec Portal.</p>
                <p>
                    Dieses Portal wird in Zukunft abgeschaltet! Alle Funktionen finden Sie auf <a href="https://www.lanet3.com">www.lanet3.com</a>!
                </p> 
                <p>
                    Die Bestenlisten Administration finden Sie auf <a href="https://statistics.lanet3.com">statistics.lanet3.com</a>!
                </p>    
                <p>
                    Sollten Sie keine Bestenlisten sehen, müssen Sie nochmals die Statistiker Rolle für Ihren Verein, Kreis, Bezirk oder LV beantragen!
                </p>                
               <p>                    
                    Bitte entschuldigen Sie die Unannehmlichkeiten.
                </p>      
                <p>
                   Bei Fragen wenden Sie sich bitte an support@seltec-sports.com
                </p>            
            </div>
        </template>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import Page from '../general/Page.vue';
import namespace from '../store/namespace';

import PageSubTitle from '../general/PageSubTitle.vue';
import Login from '../auth/Login.vue';

export default {
	name: 'Dashboard',
	components: {
		Page,
		PageSubTitle,
		Login,
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
        ...mapGetters(namespace.USER, ['User']),
	},
    mounted() {
		console.log(this.User)
        if (this.User.languageCode == 'de'){
            this.$i18n.locale = 'gr';
        } else if (this.User.languageCode == 'en'){
            this.$i18n.locale = 'en';
        }
	},
};
</script>
